import React, { createContext } from 'react'

export const GlobalContext =
  // @ts-ignore
  createContext<[TypeGlobalContext, React.Dispatch<React.SetStateAction<TypeGlobalContext>>]>(null)

export type TypeGlobalContext = {
  isSkeletonPage: boolean
}
